import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './DeleteButton.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/pro-regular-svg-icons/faTrashCan';

interface DeleteButtonProps {
    className?: string;
    onClick?: () => void;
}

export const DeleteButton: FunctionComponent<DeleteButtonProps> = props => {
    return (
        <div
            className={clsx(styles.container, props.className)}
            onClick={props.onClick}
        >
            <FontAwesomeIcon
                icon={faTrashCan}
                fontSize={14}
            />
        </div>
    );
};

export default DeleteButton;
